import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=148dfdbc&scoped=true&"
import script from "./bank.vue?vue&type=script&lang=js&"
export * from "./bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148dfdbc",
  null
  
)

export default component.exports